/**
 * 灵犀埋点相关
 */
export default class LxConstant {
  /**
     * CommonEmptyCard
     */
  // 页面曝光
  static COMMON_EMPTY_CARD_MV = 'b_sailor_c_0icdyc49_mv';
  // 按钮点击
  static COMMON_EMPTY_CARD_BUTTON_MC = 'b_sailor_c_0icdyc49_mc';
}
